/** Single source of role names — must match Infrastructure.Authentication.Roles on the server. */
export const Roles = {
  User: 'User',
  Admin: 'Admin',
  AdminService: 'AdminService',
  ServiceProvider: 'ServiceProvider',
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];
